export enum TermsConditions {

    /*Terms Accept Notification */
    terms_notify_success_heading = "Terms Accepted",
    terms_notify_success_body = "ALM Studio terms and conditions successfully accepted.",
    terms_notify_failed_heading = "Terms not Accepted",
    terms_notify_failed_body = "Sorry, but we’re having trouble signing you in. Your user ID is not active. Please contact the system administrator.",
}
